import request from '@/utils/request'
/**
 *
 * 前台用户界面相关
 *
 */

// 获取地区列表
export function getAreaList(params) {
  return request({
    url: '/admin/area',
    method: 'get',
    params,
  })
}

// 获取职位列表
export function getPositionList(data) {
  return request({
    url: '/api/position/list',
    method: 'post',
    data,
  })
}

// 获取学校信息
export function getSchoolInfo(params) {
  return request({
    url: '/api/live/schoolInfo',
    method: 'get',
    params,
  })
}

// 获取直播列表
export function getLiveList(params) {
  return request({
    url: '/api/live/list',
    method: 'get',
    params,
  })
}

// 获取直播详情
export function getLiveDetail(params) {
  return request({
    url: '/api/live/detail',
    method: 'get',
    params,
  })
}
// 获取jssdk初始化参数
export function jsdkSignature(params) {
  return request({
    url: '/api/jssdk',
    method: 'get',
    params,
  })
}

// 根据code获取用户信息：openid、头像等
export function getUserInfo(data) {
  return request({
    url: '/api/auth',
    method: 'post',
    data,
  })
}

// 用户订阅直播
export function subscribeLive(data) {
  return request({
    url: '/api/subscribe',
    method: 'post',
    data,
  })
}

// 学校列表
export function getSchoolList(params) {
  return request({
    url: '/api/school/list',
    method: 'get',
    params,
  })
}

export function getForm(params) {
  return request({
    url: '/api/form',
    method: 'get',
    params,
  })
}

export function saveForm(params) {
  return request({
    url: '/api/form/submit',
    method: 'post',
    params,
  })
}

/**
 *
 * 机器人聊天相关
 *
 */
// 获取机器人聊天信息
export function getChatInfo(params) {
  return request({
    url: '/api/chat/info',
    method: 'get',
    params,
  })
}
